import React from 'react';
import MiniSelectBox from "../Componnets/MiniSelectBox";
import {Scrollbars} from "react-custom-scrollbars";
import http from "../../services/api/utilities/http";
import {getSavedMapping, getSelectedMapping, getMappedPreview} from './connectorMapping';
export default class IPInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            res:{},
            mapping:[],
            loading:false,
            loading1:false,
            reset:false,
            dataMapping:[],
            mappingReady:false,
            error:'',
        };
    }
    // const [res, setRes] = useState(false);
    // const [mapping, setMapping] = useState([]);
    // const [loading, setLoading] = useState(false);
    // const [loading1, setLoading1] = useState(false);
    // const [reset, setReset] = useState(true);
    // useEffect(()=>{
    //     getData()
    // },[])
    componentDidMount() {
        this.getData()
    }

     getData = () => {
        http.get('data_connector/data_pool_info/'+this.props.uid)
            .then(async res => {
                const connector = res.data.data
                let mapping = getSavedMapping(connector.data_mapping)
                if (!mapping) {
                    const columns = await http.get(`data_connector/data_pool_handler/${this.props.uid}/columns/`)
                    mapping = getSelectedMapping(columns.data.data)
                }
                const mappingReady = Boolean(mapping)
                this.setState({
                    res: mappingReady ? getMappedPreview(connector.data_preview, mapping) : {},
                    mapping: mappingReady ? mapping : [],
                    mappingReady,
                    error: mappingReady ? '' : 'The saved column mapping is unavailable. Please ask the connector owner to save it again.',
                })
                // setRes(data)
                // dataMap(data)
            })
            .catch(err=>{
                console.log(err.response)
                this.setState({error:'Unable to retrieve the saved connector. Please reopen it to try again.'})
            })
    }

    verifyClose = st => {
        if(this.state.mappingReady && !this.state.loading && !this.state.loading1){
            this.setState({error:''})
            if(st === 'close')
                this.setState({loading:true})
            else
                this.setState({loading1:true})
           // http.post('data_connector/data_pool_load/'+this.props.uid+'/verify/',
           http.put('data_connector/data_pool_handler/'+this.props.uid+'/',
             {
                 name:this.props.name,
                 start_now:true,
                 data_mapping:this.state.mapping,
                 datetime:null,
             })
             .then(res => {
               if(st === 'close')
                 this.props.getData()
                 else{
                   this.props.goNext()
                   this.setState({loading1:false})
               }
             })
             .catch(err=>{
                 console.log(err.response)
                 this.setState({loading:false, loading1:false, error:'Unable to load the connector. Please try again.'})
             })
     }
    }
    // resetToDefault = () => {
    //     setReset(false)
    //     setReset(true)
    // }
    render() {
        const {res,loading,loading1,mappingReady,error} = this.state
        return (
            <div className="data-connector-verification">
                <div className="d-flex justify-content-between">
                    <div>
                        <p className="title-text">This is what this connector has suggested a the final view.</p>
                        <p className="blue-navy">Do the manipulations you need!</p>
                    </div>
                    {
                        !this.props.readOnly &&
                        <div  className="btn btn-outline d-flex justify-content-center">
                            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.41658 19.1325L9.41663 19.1325C9.67326 18.9009 9.69528 18.504 9.46624 18.2451C9.46623 18.2451 9.46623 18.2451 9.46622 18.2451L8.50976 17.164H9C13.4955 17.164 17.15 13.4715 17.15 8.93559C17.15 4.39966 13.4955 0.707147 9.00004 0.707147C4.50461 0.707147 0.85 4.39966 0.85 8.93559C0.85 9.28166 1.12824 9.56474 1.47449 9.56474C1.82076 9.56474 2.09899 9.28162 2.09899 8.93559C2.09899 5.09097 5.19628 1.96547 9 1.96547C12.8037 1.96547 15.901 5.09101 15.901 8.93559C15.901 12.7801 12.8037 15.9057 9 15.9057H8.50976L9.46622 14.8245C9.69529 14.5657 9.67321 14.1687 9.41664 13.9372C9.15915 13.7049 8.76351 13.7277 8.5338 13.9873L8.64615 14.0867L8.5338 13.9873L6.85115 15.8893L6.96349 15.9887L6.85114 15.8893C6.5255 16.2574 6.5255 16.8122 6.85114 17.1804L8.5338 19.0823C8.65705 19.2217 8.82835 19.2929 9.00018 19.2929C9.14856 19.2929 9.29762 19.2397 9.41658 19.1325Z" fill="#8A0FFF" stroke="#8A0FFF" strokeWidth="0.3"/>
                            </svg>
                            <span className="ml-3">RESET EDITS</span>
                        </div>
                    }
                </div>
                <Scrollbars
                    renderTrackHorizontal={({ style, ...props }) =>
                        <div {...props} style={{ ...style, backgroundColor: '#C2C7ED', width: "98%", borderRadius: 4, height: 1, bottom: 20, right: "1%" }}/>
                    }
                    renderThumbHorizontal={({ style, ...props }) =>
                        <div {...props} style={{ ...style, backgroundColor: '#70789E', borderRadius: 4, cursor: "pointer", height: 5, bottom: 2 }}/>
                    }
                    className="scroll --table" style={{ width: 839, height: 345 }}>
                    <div className="table wmc table-select d-flex justify-content-center">
                        <table>
                            <thead>
                            <tr >
                                {
                                    Object.keys(res).map((key,index) => {
                                        return <th key={index}>
                                          <MiniSelectBox title={key} variable="integer" readOnly={this.props.readOnly} />
                                        </th>
                                    })
                                }
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                {
                                    Object.keys(res).map((key) => {
                                        return <td>{res[key][0]}</td>
                                    })
                                }
                            </tr>
                            <tr>
                                {
                                    Object.keys(res).map((key) => {
                                        return <td>{res[key][1]}</td>
                                    })
                                }
                            </tr>
                            <tr>
                                {
                                    Object.keys(res).map((key) => {
                                        return <td>{res[key][2]}</td>
                                    })
                                }

                            </tr>
                            <tr>
                                {
                                    Object.keys(res).map((key) => {
                                        return <td>{res[key][3]}</td>
                                    })
                                }
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                {
                                    Object.keys(res).map((key) => {
                                        return <td>{res[key][4]}</td>
                                    })
                                }

                            </tr>
                            </tfoot>

                        </table>
                    </div>
                </Scrollbars>

                {!this.props.readOnly && error && <p role="alert">{error}</p>}
                {
                    !this.props.readOnly ?
                        <div className="d-flex mt-32 justify-content-center">
                            {/*<div onClick={verifyClose} className="btn btn-outline mr-32">VERIFY AND CLOSE</div>*/}
                            <div onClick={() => this.verifyClose('close')} aria-disabled={!mappingReady || loading || loading1} className={`${!mappingReady ? 'btn-disable' : ''} ${loading && 'btn-loading-small'} btn btn-by-loading btn-active btn-outline mr-32`}>
                                <p>VERIFY AND CLOSE</p>
                                <p>VERIFY AND CLOSING</p>
                            </div>
                            {/*<div onClick={() => this.verifyClose('load')} className={`${loading1 && 'btn-loading-small'} btn btn-by-loading btn-active`}>*/}
                            {/*    <p>VERIFY AND LOAD</p>*/}
                            {/*    <p>VERIFY AND LOADING</p>*/}
                            {/*</div>*/}
                        </div> :
                        <div className="d-flex mt-40 justify-content-center">
                            {/*<div onClick={verifyClose} className="btn btn-outline mr-32">VERIFY AND CLOSE</div>*/}
                            <div onClick={this.props.close} className={`${loading && 'btn-loading-small'} btn btn-by-loading btn-active mr-32`}>
                                <p>OK</p>
                            </div>
                        </div>
                }
            </div>
        );
    }
}
